import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  getLocalTypeaheadList,
} from 'AppSrc/core/actions/actions-typeahead-lists';
import {
  CrossSvg,
} from 'AppSrc/core/components/common/svg-icons';
import PropTypes from 'prop-types';
import { debounce } from 'underscore';
import 'AppSrc/core/style/components/form/form-base-components/templated-option-button/templated-option-button-head.css';


class TypeaheadHead extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
    };

    this.updateValue = this.updateValue.bind(this);
    this.getLocalTypeaheadList = debounce(this.props.getLocalTypeaheadList, 300);
    this.onFocus = this.onFocus.bind(this);
    this.clearValue = this.clearValue.bind(this);
  }

  onFocus() {
    const {
      selectedDisplayValue,
      openDropdown,
    } = this.props;
    if (selectedDisplayValue) {
      this.setState({
        inputValue: selectedDisplayValue,
      });
    }
    openDropdown();
  }

  updateValue(e) {
    const {
      fieldId,
    } = this.props;

    const value = e.target.value;

    this.setState({
      inputValue: value,
    });

    if (value.length > 0) {
      this.getLocalTypeaheadList(fieldId, value);
    }
  }

  clearValue(e) {
    this.setState({
      inputValue: '',
    });

    this.props.clearValue(e);
  }

  render() {
    const {
      selectedDisplayValue,
      placeholder,
      disabled,
      dropdownOpen,
      clearValue,
    } = this.props;

    const selectedValue = selectedDisplayValue ? selectedDisplayValue : ''; // if this is selectedDisplayValue, make it ''

    const {
      inputValue,
    } = this.state;

    const hasValue = selectedValue || (inputValue.length > 0);

    // clearValue is optional
    const showClear = hasValue && clearValue;

    return (
      <div className="template-option-head template-option-head-typeahead">
        <input
          className="template-option-head-typeahead"
          onChange={this.updateValue}
          onFocus={this.onFocus}
          value={dropdownOpen ? inputValue : selectedValue}
          placeholder={placeholder}
          disabled={disabled}
        />
        {
          showClear && (
            <button
              type="button"
              className="svg-wrapper"
              onClick={this.clearValue}
              disabled={disabled}
            >
              <CrossSvg />
            </button>
          )
        }
      </div>
    );
  }
}



const mapStateToProps = (state, ownProps) => ({
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getLocalTypeaheadList: (fieldId, value) => {
    dispatch(getLocalTypeaheadList(fieldId, value));
  },
});


TypeaheadHead = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TypeaheadHead);





TypeaheadHead.propTypes = {
  selectedDisplayValue: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  dropdownOpen: PropTypes.bool,
  openDropdown: PropTypes.func,
  getLocalTypeaheadList: PropTypes.func,
  fieldId: PropTypes.string,
  clearValue: PropTypes.func,
};

export { TypeaheadHead };

